import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { Button, Label } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { serverURL } from '../constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Profile = () => {

    const [mName, setName] = useState(localStorage.getItem('mName'));
    const [email, setEmail] = useState(localStorage.getItem('email'));
    const [password, setPassword] = useState('');
    const [processing, setProcessing] = useState(false);
    const [telegramToken, setTelegramToken] = useState(localStorage.getItem('telegramToken') || '');

    useEffect(() => {
        const storedToken = localStorage.getItem('telegramToken');
        if (storedToken) {
            setTelegramToken(storedToken);
        }
    }, []);
    const navigate = useNavigate();
    function redirectSubscription() {
        navigate("/subscription");
    }

    const showToast = async (msg) => {
        setProcessing(false);
        toast(msg, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!email || !mName) {
            showToast('Please fill in all required fields');
            return;
        }
        setProcessing(true);
        const uid = localStorage.getItem('uid');
        const postURL = serverURL + '/api/profile';
        try {
            const response = await axios.post(postURL, { email, mName, password, uid });
            if (response.data.success) {
                showToast(response.data.message);
                localStorage.setItem('email', email);
                localStorage.setItem('mName', mName);
                setProcessing(false)
            } else {
                showToast(response.data.message);
            }
        } catch (error) {
            showToast('Internal Server Error');
        }
    }
    const deleteToken = async () => {
        const userId = localStorage.getItem('uid');
        if (!userId) {
            toast.error('User ID not found');
            return;
        }
        setProcessing(true);
        try {
            const response = await axios.delete(`${serverURL}/api/telegram-token/delete`, {
                data: { userId },
            });
            if (response.data.success) {
                setTelegramToken('');
                localStorage.removeItem('telegramToken'); // Remove from localStorage
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Failed to delete token');
        } finally {
            setProcessing(false);
        }
    };
    const regenerateToken = async () => {
        const userId = localStorage.getItem('uid');
        if (!userId) {
            toast.error('User ID not found');
            return;
        }
        setProcessing(true);
        try {
            const response = await axios.put(`${serverURL}/api/telegram-token/regenerate`, { userId });
            if (response.data.success) {
                const newToken = response.data.token;
                setTelegramToken(newToken);
                localStorage.setItem('telegramToken', newToken); // Save to localStorage
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Failed to regenerate token');
        } finally {
            setProcessing(false);
        }
    };
    const generateToken = async () => {
        const userId = localStorage.getItem('uid');
        if (!userId) {
            toast.error('User ID not found');
            return;
        }
        setProcessing(true);
        try {
            const response = await axios.post(`${serverURL}/api/telegram-token/generate`, { userId });
            if (response.data.success) {
                const newToken = response.data.token;
                setTelegramToken(newToken);
                localStorage.setItem('telegramToken', newToken); // Save to localStorage
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Failed to generate token');
        } finally {
            setProcessing(false);
        }
    };






    return (
        <div className='h-screen flex flex-col'>
            <Header isHome={true} className="sticky top-0 z-50" />
            <div className='dark:bg-black flex-1'>
                <div className='flex-1 flex items-center justify-center py-10 flex-col'>
                    <form onSubmit={handleSubmit} className="md:w-2/5 w-4/5 m-auto py-4 no-scrollbar ">
                        <p className='text-center font-black text-4xl text-black dark:text-white'>Profile</p>
                        <div className='py-6'>
                            <div className='mb-6'>
                                <div className="mb-2 block">
                                    <Label className="font-bold text-black dark:text-white" htmlFor="name1" value="Name" />
                                </div>
                                <input value={mName} onChange={(e) => setName(e.target.value)} className='focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white' id="name1" type="text" />
                            </div>
                            <div className='mb-6'>
                                <div className="mb-2 block">
                                    <Label className="font-bold text-black dark:text-white" htmlFor="email1" value="Email" />
                                </div>
                                <input value={email} onChange={(e) => setEmail(e.target.value)} className='focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white' id="email1" type="email" />
                            </div>
                            <div className='mb-14'>
                                <div className="mb-2 block">
                                    <Label className="font-bold text-black dark:text-white" htmlFor="password1" value="New Password" />
                                </div>
                                <input value={password} onChange={(e) => setPassword(e.target.value)} className='focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white' id="password1" type="password" />
                            </div>
                            <div className='mb-14'>
                                <div className="mb-2 block">
                                    <Label className="font-bold text-black dark:text-white" htmlFor="telegramToken" value="Telegram Token" />
                                </div>
                                <input
                                    value={telegramToken}
                                    readOnly
                                    className='focus:ring-black focus:border-black border border-black font-normal bg-gray-200 rounded-none block w-full dark:bg-gray-800 dark:border-white dark:text-white'
                                    id="telegramToken"
                                    type="text"
                                />
                                <Button onClick={generateToken} className='mt-4 bg-green-600 text-white w-full'>Generate</Button>
                                <Button onClick={regenerateToken} className='mt-2 bg-blue-600 text-white w-full'>Regenerate</Button>
                                <Button onClick={deleteToken} className='mt-2 bg-red-600 text-white w-full'>Delete</Button>
                            </div>



                            <Button isProcessing={processing} processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />} className='items-center justify-center text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none w-full enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent' type="submit">Submit</Button>
                            <Button onClick={redirectSubscription} className='my-6 items-center justify-center text-center border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none w-full enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent'>Manage Subscriptions</Button>
                        </div>

                    </form>
                </div>
            </div>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Profile;
